export default __webpack_public_path__ + "static/4-2_Lense_Specifications-300d1e95ca4237cc76ade35eeadeb487.webp";